import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer, Hidden, useMediaQuery, useTheme } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useCollapsed, useMobileOpen } from './MainLayoutContext';
import { MainSideMenuContent } from './MainSideMenuContent';
export const MainSideMenu = ({ items, disabled = false, children }) => {
    const [openMobile, setOpenMobile] = useMobileOpen();
    const [collapsed, setCollapsed] = useCollapsed();
    const location = useLocation();
    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    useEffect(() => {
        if (isSmDown && collapsed) {
            setCollapsed(false);
        }
    }, [isSmDown]);
    useEffect(() => {
        if (openMobile && setOpenMobile) {
            setOpenMobile(false);
        }
    }, [location.pathname]);
    return (_jsxs(React.Fragment, { children: [_jsx(Hidden, { smUp: true, children: _jsx(Drawer, { onClose: () => setOpenMobile(false), open: openMobile, anchor: 'left', variant: 'temporary', children: _jsx(MainSideMenuContent, { items: items, disabled: disabled, children: children }) }) }), _jsx(Hidden, { smDown: true, children: _jsx(Drawer, { PaperProps: {
                        style: { height: 'calc(100% - 5rem)', top: '5rem', zIndex: 10, width: collapsed ? '5rem' : '12rem' }
                    }, anchor: 'left', open: true, variant: 'persistent', children: _jsx(MainSideMenuContent, { items: items, disabled: disabled, children: children }) }) })] }));
};
